let searchValid = function(val){
	console.log('searchValid', val)	
};
export default searchValid;
